import { render, staticRenderFns } from "./SwitchingCentreBasic.vue?vue&type=template&id=1cf81880&"
import script from "./SwitchingCentreBasic.vue?vue&type=script&lang=js&"
export * from "./SwitchingCentreBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports